import { useInfrastructureWizard } from '@/stores/infrastructureWizard'
import type { InfraLevel } from '@/types/infrastructure'
import styles from './Infrastructure.module.css'
import { OptionCard } from './OptionCard'

/** "Is this for AppCentral level or Domain level?" The answer decides which branch the Servers step shows. */
export function LevelStep() {
  const level = useInfrastructureWizard((s) => s.level)
  const setLevel = useInfrastructureWizard((s) => s.setLevel)
  return (
    <fieldset className={styles.cardGroup}>
      <legend className={styles.legend}>Is this for AppCentral level or Domain level?</legend>
      <OptionCard
        name="infra-level"
        value="appCentral"
        checked={level === 'appCentral'}
        onChange={(value) => setLevel(value as InfraLevel)}
        title="AppCentral level"
        description="The application tier, with its Azure SQL database."
      />
      <OptionCard
        name="infra-level"
        value="domain"
        checked={level === 'domain'}
        onChange={(value) => setLevel(value as InfraLevel)}
        title="Domain level"
        description="An RDS server and a SQL server for a domain."
      />
    </fieldset>
  )
}
